import Api from '../index';

const EventosService = {
  getEventos: async () => {
    try {
      const response = await Api.get('/eventos/listarEventos');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getExperiencias: async (eventoId) => {
    try {
      const response = await Api.get(`/eventos/${eventoId}/experiencias`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getEventoPorId: async (id) => {
    try {
      const response = await Api.get(`/eventos/buscarEventoPorId`, {
        params: { id }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createExperiencia: async (eventoId, texto) => {
    try {
      const response = await Api.post(`/eventos/${eventoId}/experiencias`, { texto });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createEvento: async (eventoData) => {
    try {
      // Corrigido para a rota correta do backend
      const response = await Api.post('/eventos/criarEvento', eventoData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateEvento: async (id, eventoData) => {
    try {
      const response = await Api.patch(`/eventos/atualizarEvento?id=${id}`, eventoData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  deleteEvento: async (id) => {
    try {
      const response = await Api.delete(`/eventos/deletarEvento?id=${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  
  // If we need a specific upload endpoint
  marcarConfirmacaoEnviada: async (eventoId, inscricaoId) => {
    try {
      const response = await Api.patch('/eventos/marcarConfirmacao', { eventoId, inscricaoId });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  uploadImagem: async (formData) => {
      try {
          const response = await Api.post('/eventos/upload', formData, {
              headers: {
                  'Content-Type': 'multipart/form-data',
              },
          });
          return response.data;
      } catch (error) {
          throw error;
      }
  }
};

export default EventosService;
